import React, { useState, useEffect } from 'react';
import ErrorMessage from '../../interface/ErrorMessage';
import PreloadButton from '../../interface/PreloadButton';
import { getPath } from '../../utils/getPath';
import { useLocalStore, observer } from 'mobx-react';
import { RequestStore } from '../../stores';
import { DateRangePicker, LocalizationProvider } from '@material-ui/pickers';
import MomentUtils from '@material-ui/pickers/adapter/moment';
import moment from 'moment';
import { Radio, Box, Input, RadioGroup, FormControlLabel } from '@material-ui/core';
import { CloseBtn, Title } from '../UI/Modal';
import Modal from 'react-modal';
import SuccessModal from './SuccessModal';

const ReqForm1 = observer(({ open, onClose }) => {
    const store = useLocalStore(() => new RequestStore());
    const [selectedPeriod, setSelectedPerios] = useState([null, null]);
    const [values, setValues] = useState({
        reason: '',
        comment: '',
        type: 'Аренда',
        period: '',
    });

    // Effects
    useEffect(() => {
        return () => {
            setValues({
                reason: '',
                comment: '',
                type: 'Аренда',
                period: '',
            });
        };
    }, []);

    // Handlers
    const handleChange = e => {
        setValues({
            ...values,
            [e.target.name]: e.target.value,
        });
    };

    const handleDateChange = date => {
        setSelectedPerios(date);
        setValues({
            ...values,
            period: `${date[0] ? moment(date[0]).format('DD.MM.YYYY') : ''} - ${date[1] ? moment(date[1]).format('DD.MM.YYYY') : ''}`,
        });
    };

    const handleSended = () => {
        setValues({
            reason: '',
            comment: '',
            type: 'Аренда',
            period: '',
        });
        onClose();
    };

    const handleSubmit = e => {
        e.preventDefault();

        store.submitForm1(values, handleSended);
    };

    // Renders
    if (store.success) {
        return <SuccessModal open={true} />;
    }

    return (
        <Modal
            isOpen={open}
            onClose={onClose}
            onRequestClose={onClose}
            className="Modal request-modal"
            overlayClassName="Overlay"
            ariaHideApp={false}
        >
            <CloseBtn onClose={onClose} />
            <Title>Обратная связь</Title>

            {store.errorMessage.length ? <ErrorMessage message={store.errorMessage} /> : null}

            <form onSubmit={handleSubmit}>
                <Box mb={3}>
                    <Input
                        multiline
                        fullWidth
                        rows={5}
                        // required
                        name="reason"
                        value={values.reason}
                        onChange={handleChange}
                        placeholder="Какую задачу требуется решить?"
                    />
                </Box>

                <Box mb={3}>
                    <Input
                        multiline
                        fullWidth
                        rows={5}
                        required
                        name="comment"
                        value={values.comment}
                        onChange={handleChange}
                        placeholder="Какая техника требуется?"
                    />
                </Box>

                <Box mb={2}>
                    <RadioGroup name="type" value={values.type} onChange={handleChange} required>
                        <FormControlLabel value="Аренда" control={<Radio />} label="Аренда" />
                        <FormControlLabel value="Покупка" control={<Radio />} label="Покупка" />
                    </RadioGroup>
                </Box>

                <Box mb={3}>
                    <LocalizationProvider dateAdapter={MomentUtils} locale="ru">
                        <DateRangePicker
                            mask="__.__.____"
                            startText="Дата от"
                            endText="Дата до"
                            value={selectedPeriod}
                            onChange={date => handleDateChange(date)}
                            showToolbar={true}
                            okText="Выбрать"
                            cancelText="Отмена"
                            renderInput={(startProps, endProps) => (
                                <div className="period-input">
                                    <input
                                        type="text"
                                        className="legal-form__input period-input__input"
                                        value={
                                            selectedPeriod[0]
                                                ? `${moment(selectedPeriod[0]).format('DD.MM.YYYY')} - ${
                                                      endProps.inputProps.value || 'Дата до'
                                                  }`
                                                : ''
                                        }
                                        onFocus={() => startProps.inputProps.onFocus()}
                                        placeholder="Период аренды"
                                        required
                                    />
                                    <div className="period-input__calendar-btn">
                                        <img src={getPath('public/img/calendar-month.svg')} alt="" />
                                    </div>
                                </div>
                            )}
                        />
                    </LocalizationProvider>
                </Box>

                <PreloadButton isLoad={store.loading}>Отправить заявку</PreloadButton>
            </form>
        </Modal>
    );
});

export default ReqForm1;
